import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/joy";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ShoppingCart,
  Dashboard,
  People,
  BarChart,
  Layers,
  Settings,
  ProductionQuantityLimits,
  AccountBox,
  AddShoppingCartRounded,
  Payment,
  CurrencyRupeeTwoTone,
  HeadsetMicTwoTone,
  CelebrationOutlined,
  CurrencyBitcoinOutlined,
  CurrencyYuanSharp,
  CurrencyRupeeOutlined,
  EditNotificationsOutlined,
  EditNote,
  WidthFull,
  ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import DashboardContent from "./dashboardContent";

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import ProductManagement from "./productManagement";
import OrderManagement from "./orderManagement";
import CustomerMnagement from "./customerManagement";
import SettingsPage from "./settings-page";
import InventoryManagement from "./InventoryManagement";
import LegalprivacyPolicy from "./LegalprivacyPolicy";
import CommunicationManagement from "./CommunicationManagement";
import PaymentManagement from "./PaymentManagement";
import ReturnandRefundPolicy from "./ReturnandRefundPolicy";
import IntegrationwithDeliverySystem from "./IntegrationwithDeliverySystem";
import MarkertandPromotions from "./MarketingandPromotion";
import MenuIcon from "@mui/icons-material/Menu";
import VendorProduct from "./VendorProduct";
import ProfilePage from "./ProfilePage";
import { useSelector } from "react-redux";
import ListingPaymentManagement from "../ListingPaymentManagement";

const tabToSlug = {
  Dashboard: "dashboard",
  "Product Management": "products",
  "Listing Management": "listings",
  "Order Management": "orders",
  "Inventory Management": "inventory",
  "Payment Management": "payments",
  "Delivery Orders Management": "delivery-orders",
  "Delivery Management": "delivery",
  "Marketing & Promotions": "marketing",
  "Settings & Configuration": "settings",
  "Communication Management": "communication",
  ProfilePage: "profile",
};
const slugToTab = Object.fromEntries(
  Object.entries(tabToSlug).map(([k, v]) => [v, k]),
);
const Analytics = () => <div>Analytics Content</div>;
const Transactions = () => <div>Transactions Content</div>;
const SettingsConfiguration = () => <div>Settings & Configuration Content</div>;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rolePermissions = useSelector(
    (state) => state.user.userdetails?.role_permissions || {},
  );
  const userdetails = useSelector((state) => state.user.userdetails || {});

  const getInitialTab = () => {
    const slug = location.pathname.split("/")[2];
    return slugToTab[slug] || "Dashboard";
  };

  const [activeTab, setActiveTab] = useState("Dashboard");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showProductForm, setShowProductForm] = useState(false);
  const [sname, setSName] = useState("");

  useEffect(() => {
    document.title = `Sthanick | ${activeTab}`;
  }, [activeTab]);

  // Sync activeTab if user navigates back/forward
  useEffect(() => {
    const slug = location.pathname.split("/")[2];
    const tab = slugToTab[slug] || "Dashboard";
    if (tab !== activeTab) setActiveTab(tab);
  }, [location.pathname]);

  console.log("72", userdetails.vtype);
  const tabPermissions = {
    Dashboard: "dashboard_management", //dashboard_management
    "Product Management": "product_management", // For regular vendor
    "Listing Management": "product_management", // For listing vendor
    "Order Management": "order_management",
    "Inventory Management": "inentory_management",
    "Payment Management": "payment_management", // For both vendors
    "Delivery Orders Management": "delivery_orders_management", // For regular vendor
    "Delivery Management": "delivery_orders_management", // For listing vendor
    // "Financial Management": "financial_management",
    "Marketing & Promotions": "marketing_and_promotions",
    "Settings & Configuration": "settings_configuration",
    "Communication Management": "communication_management",
  };
  const handleTabClick = (tab) => {
    const permissionKey = tabPermissions[tab];
    if (rolePermissions[permissionKey]) {
      setActiveTab(tab);
      navigate(
        tab === "Dashboard"
          ? "/vendor-dashboard"
          : `/vendor-dashboard/${tabToSlug[tab]}`,
      );
    } else {
      console.log(`User doesn't have permission for ${tab}`);
    }
  };
  const handleScreeName = (sname) => {
    setSName(sname);
    setActiveTab(sname);
    navigate(
      sname === "Dashboard"
        ? "/vendor-dashboard"
        : `/vendor-dashboard/${tabToSlug[sname] || sname.toLowerCase().replace(/ /g, "-")}`,
    );
  };

  const toggleSidebar = () => setIsCollapsed(!isCollapsed);

  const renderContent = () => {
    switch (activeTab) {
      case "Dashboard":
        return <DashboardContent onBackScreenName={handleScreeName} />;
      case "Product Management":
        return <VendorProduct onBackScreenName={handleScreeName} />; // For regular vendor
      case "Listing Management":
        return <VendorProduct onBackScreenName={handleScreeName} />; // For listing vendor
      case "Order Management":
        return <OrderManagement onBackScreenName={handleScreeName} />;
      case "Inventory Management":
        return <InventoryManagement onBackScreenName={handleScreeName} />;
      case "Payment Management":
        // Show ListingPaymentManagement for listing vendors, PaymentManagement for regular vendors
        if (userdetails.vtype === "vlistuser") {
          return (
            <ListingPaymentManagement onBackScreenName={handleScreeName} />
          );
        }
        return <PaymentManagement onBackScreenName={handleScreeName} />;
      // case "Return & Refund Policy":
      //   return <ReturnandRefundPolicy />;
      case "Delivery Orders Management":
        if (userdetails.vtype !== "vlistuser") {
          return (
            <IntegrationwithDeliverySystem onBackScreenName={handleScreeName} />
          ); // For regular vendor
        }
        break;

      case "Delivery Management":
        if (userdetails.vtype === "vlistuser") {
          return (
            <IntegrationwithDeliverySystem onBackScreenName={handleScreeName} />
          ); // For listing vendor
        }
        break;

      case "Marketing & Promotions":
        return <MarkertandPromotions onBackScreenName={handleScreeName} />;
      case "Settings & Configuration":
        return <SettingsPage onBackScreenName={handleScreeName} />;
      case "Communication Management":
        return <CommunicationManagement onBackScreenName={handleScreeName} />;
      case "ProfilePage":
        return <ProfilePage onBackScreenName={handleScreeName} />;
      // case "Legal Policy Information":
      //   return <LegalprivacyPolicy />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        width: "100%",
        maxWidth: "100vw",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Sidebar */}
      <Box
        sx={{
          width: isCollapsed ? "80px" : "250px",
          transition: "width 0.3s ease",
          backgroundColor: "#fff",
          boxShadow: 1,
          overflowY: "auto",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari/Edge
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: isCollapsed ? "center" : "space-between",
            padding: "16px",
          }}
        >
          {!isCollapsed && (
            // <Box>
            //   <Typography
            //     component="h2"
            //     variant="h6"
            //     sx={{ fontSize: "1.5rem", fontWeight: "bold" }}
            //   >
            //     <span style={{ color: "#2986cc" }}>S</span>
            //     <span style={{ color: "#f97300" }}>t</span>
            //     <span style={{ color: "#4ea8de" }}>h</span>
            //     <span style={{ color: "#2986cc" }}>a</span>
            //     <span style={{ color: "#f97300" }}>n</span>
            //     <span style={{ color: "#4ea8de" }}>i</span>
            //     <span style={{ color: "#2986cc" }}>c</span>
            //     <span style={{ color: "#f97300" }}>k</span>
            //   </Typography>
            // </Box>

            <Box
              component="img"
              src="/Sthanick.jpeg"
              alt="Sthanick"
              sx={{
                height: 40,
                width: "auto",
              }}
            />
          )}
          {/* Arrow Icon */}
          <IconButton
            onClick={toggleSidebar}
            sx={{
              position: "absolute",
              top: "50%",
              right: isCollapsed ? "-15px" : "-15px",
              transform: "translateY(-50%)",
              backgroundColor: "#fff",
              boxShadow: 1,
              "&:hover": { backgroundColor: "#f0f0f0" },
              zIndex: 1,
            }}
          >
            {isCollapsed ? <ArrowForwardIos /> : <ArrowBackIos />}
          </IconButton>
        </Box>
        {/* Sidebar List */}
        <Box
          sx={{
            flex: 1, // Allow the box to take available space
            overflowY: "auto", // Enable scrolling
            scrollbarWidth: "none", // Hide scrollbar for Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar for Chrome, Safari, and Edge
            },
          }}
        >
          <List>
            {[
              {
                text: "Dashboard",
                icon: <Dashboard />,
                permission: "dashboard_management",
              },
              {
                text:
                  userdetails?.vtype == "vlistuser"
                    ? "Listing Management"
                    : "Product Management",
                icon: <ShoppingCart />,
                permission: "product_management",
              },
              {
                text: "Order Management",
                icon: <ShoppingCart />,
                permission: "order_management",
              },
              {
                text: "Inventory Management",
                icon: <People />,
                permission: "inentory_management",
              },
              {
                text: "Payment Management",
                icon: <CurrencyRupeeTwoTone />,
                permission: "payment_management",
              },
              userdetails?.vtype !== "vlistuser"
                ? {
                    text: "Delivery Orders Management",
                    icon: <Settings />,
                    permission: "delivery_orders_management",
                  }
                : "",
              {
                text: "Marketing & Promotions",
                icon: <CelebrationOutlined />,
                permission: "marketing_and_promotions",
              },
              {
                text: "Settings & Configuration",
                icon: <Settings />,
                permission: "settings_configuration",
              },
              {
                text: "Communication Management",
                icon: <HeadsetMicTwoTone />,
                permission: "communication_management",
              },
            ]
              .filter(({ permission }) => rolePermissions[permission])
              .map(({ text, icon }) => (
                <ListItem
                  button
                  key={text}
                  onClick={() => handleTabClick(text)}
                  sx={{
                    backgroundColor:
                      activeTab === text ? "#EEF2FF" : "transparent",
                    color: activeTab === text ? "#3f51b5" : "inherit",
                    "&:hover": { backgroundColor: "#EEF2FF", color: "#3f51b5" },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: activeTab === text ? "#3f51b5" : "inherit",
                      minWidth: "40px",
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  {!isCollapsed && <ListItemText primary={text} />}
                </ListItem>
              ))}
          </List>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          overflowY: "auto",
          overflowX: "hidden",
          p: { xs: 1, sm: 2 },
        }}
      >
        {renderContent()}
      </Box>
    </Box>
  );
};

export default AdminDashboard;
